function initQuantityComponent() {
    const initQuantityLogic = {
        quantityActiveState: false,

        smallActiveState: true,
        smallQuantityState: 1,

        mediumActiveState: false,
        mediumQuantityState: 0,

        largeActiveState: false,
        largeQuantityState: 0,
        initQuantityFct(dataToSend: any) {
            if(dataToSend['how-many']) {
                // noop
            } else {
               // this.handleQuantityActiveStateFct('small')
               // this.smallQuantityState = 1
            }
        },
        loadingQuantityFct(dataToSend: any, key: any) {
            if(dataToSend['how-many']) {
                for (const [dataToSendKey] of Object.entries(dataToSend['how-many'][0])) {
                    if (key == dataToSendKey) {
                        return true
                    }
                }
                return false
            }
            return
        },
        // handleQuantityActiveStateFct(state: boolean) {
        //     if (key === 'small') {
        //         this.smallActiveState = !this.smallActiveState;
        //     } else if (key === 'medium') {
        //         this.mediumActiveState = !this.mediumActiveState;
        //     } else if (key === 'large') {
        //         this.largeActiveState = !this.largeActiveState;
        //     }

        //     this.quantityActiveState = state;

        //     if(this.smallActiveState || this.mediumActiveState || this.largeActiveState) {
        //         this.quantityActiveState = true
        //     } else {
        //         this.quantityActiveState = false
        //     }
        // },
        getQuantityStateFct(key: string) {
            if (key === 'small') {
                return this.smallQuantityState;
            } else if (key === 'medium') {
                return this.mediumQuantityState;
            } else if (key === 'large') {
                return this.largeQuantityState;
            }
            return 0;
        },
        handleQuantityFct(type: string, key: string) {
            const operator = type == 'decrease' ? -1 : +1;
            if (key == 'small') {
                this.smallQuantityState = Math.max(0, Math.min(5, this.smallQuantityState + operator));
                this.smallQuantityState == 0 ? this.smallActiveState = false : this.smallActiveState = true
            } else if (key == 'medium') {
                this.mediumQuantityState = Math.max(0, Math.min(5, this.mediumQuantityState + operator));
                this.mediumQuantityState == 0 ? this.mediumActiveState = false : this.mediumActiveState = true
            } else if (key == 'large') {
                this.largeQuantityState = Math.max(0, Math.min(5, this.largeQuantityState + operator));
                this.largeQuantityState == 0 ? this.largeActiveState = false : this.largeActiveState = true
            }
        },
    };

    return initQuantityLogic;
}

export default initQuantityComponent();
